import React from 'react'
import { useSelector } from 'react-redux'
import { Box, Tooltip } from '@mui/material'
import DOMPurify from 'dompurify'
import useTooltipEnabled from 'Hooks/useTooltipEnabled'

interface PanoramaProps {
  panoramas?: any
  assetUrl?: string
}
const Panoramas = ({ panoramas, assetUrl }: PanoramaProps) => {
  const { locId } = useSelector((state: any) => state.location)
  const tooltipEnabled = useTooltipEnabled()

  return (
    <>
      {panoramas?.map((panorama: any) => {
        const descriptionPart =
          panorama.accessibility_description || panorama.description || ''
        const accessibilityText = [panorama.title, descriptionPart]
          .filter((part) => part != null && String(part).trim() !== '')
          .join('. ')
        const imageAlt =
          accessibilityText || panorama.accessibility_description || 'Panorama'
        return (
          <div
            key={
              panorama.id || panorama.hotspotMediaId || panorama.media_id
            }
          >
            <h4>{panorama.title}</h4>
            <Box
              component={'div'}
              sx={{
                width: '100%',
                maxHeight: '450px',
                background: '#f2f3f4',
                textAlign: 'center',
              }}
            >
              <Tooltip title={accessibilityText || imageAlt} placement='top' arrow disableHoverListener={!tooltipEnabled} disableFocusListener={!tooltipEnabled} disableTouchListener={!tooltipEnabled}>
              <Box
                sx={{ maxHeight: '450px', width: '100%' }}
                component={'img'}
                src={`${assetUrl}/media/${locId}/panoramas/${
                  panorama.id || panorama.hotspotMediaId || panorama.media_id
                }/1024.jpg`}
                alt={imageAlt}
              />
              </Tooltip>
            </Box>
            <p
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(panorama.description, {
                  ADD_ATTR: ['target'],
                }),
              }}
            />
          </div>
        )
      })}
    </>
  )
}

export default Panoramas
